export default __webpack_public_path__ + "static/media/oh.92889628.png";